import React from "react";

const baseStyle = {
  position: "absolute",
  zIndex: 14,
  background: "transparent",
  touchAction: "none",
};

const BubbleResizeHandle = ({ edge, onPointerDown }) => {
  const getStyle = () => {
    const size = 12;
    switch (edge) {
      case "top":
        return {
          ...baseStyle,
          top: -4,
          left: 0,
          right: 0,
          height: 8,
          cursor: "ns-resize",
        };
      case "bottom":
        return {
          ...baseStyle,
          bottom: -4,
          left: 0,
          right: 0,
          height: 8,
          cursor: "ns-resize",
        };
      case "left":
        return {
          ...baseStyle,
          top: 0,
          bottom: 0,
          left: -4,
          width: 8,
          cursor: "ew-resize",
        };
      case "right":
        return {
          ...baseStyle,
          top: 0,
          bottom: 0,
          right: -4,
          width: 8,
          cursor: "ew-resize",
        };
      case "nw":
        return {
          ...baseStyle,
          top: -4,
          left: -4,
          width: size,
          height: size,
          cursor: "nwse-resize",
        };
      case "ne":
        return {
          ...baseStyle,
          top: -4,
          right: -4,
          width: size,
          height: size,
          cursor: "nesw-resize",
        };
      case "sw":
        return {
          ...baseStyle,
          bottom: -4,
          left: -4,
          width: size,
          height: size,
          cursor: "nesw-resize",
        };
      case "se":
        return {
          ...baseStyle,
          bottom: -4,
          right: -4,
          width: size,
          height: size,
          cursor: "nwse-resize",
        };
      default:
        return baseStyle;
    }
  };

  return <div data-testid={`bubble-resize-${edge}`} style={getStyle()} onPointerDown={onPointerDown} />;
};

export default BubbleResizeHandle;
